import * as oidc from 'oidc-client-ts';

import { Action } from './';

import {
  INITIAL_AUTHENTICATION,
  LOAD_USER_ERROR,
  OIDC_ACCESS_TOKEN_EXPIRED,
  OIDC_ACCESS_TOKEN_EXPIRING,
  OIDC_SILENT_RENEW_ERROR,
  OIDC_USER_LOADED,
  OIDC_USER_SIGNED_OUT,
  OIDC_USER_UNLOADED,
  PERFORM_TEST,
  REDIRECT_SUCCESS,
} from './actionTypes';

/**
 * Action which is dispatched after a successful redirect callback.
 * @param user
 */
export function redirectSuccess(user: oidc.User): Action<oidc.User> {
  return {
    type: REDIRECT_SUCCESS,
    payload: user,
  };
}

export const loadUserError: (error: any) => Action<any> = (error) => ({
  error: true,
  type: LOAD_USER_ERROR,
  payload: error,
});

/**
 * Action which is dispatched the first time the application authenticates.
 */
export function initialAuthention(): Action<void> {
  return {
    type: INITIAL_AUTHENTICATION,
  };
}

export function performTest(): Action<{}> {
  return {
    type: PERFORM_TEST,
  };
}

// oidc-js events

/**
 * Action which is dispatched when the user token expires.
 */
export const accessTokenExpired: () => Action<void> = () => ({
  type: OIDC_ACCESS_TOKEN_EXPIRED,
});

/**
 * Action which is dispatched when the current access token is getting close to expiration.
 */
export const accessTokenExpiring: () => Action<void> = () => ({
  type: OIDC_ACCESS_TOKEN_EXPIRING,
});

/**
 * Action which is dispatched when the user is loaded from the user manager.
 * @param user The user loaded by the user manager.
 */
export const userLoaded: (user: oidc.User) => Action<oidc.User> = (user) => ({
  type: OIDC_USER_LOADED,
  payload: user,
});

// dispatched when the user is logged out
export const userUnloaded: () => Action<void> = () => ({
  type: OIDC_USER_UNLOADED,
});

/**
 * Action which is dispatched when an error occurs whilst attempting to silently renew the user token.
 * @param error The error that occured during silent renewal.
 */
export const silentRenewError: (error: any) => Action<any> = (error) => ({
  error: true,
  type: OIDC_SILENT_RENEW_ERROR,
  payload: error,
});

// dispatched when the user signs out
export const userSignedOut: () => Action<void> = () => ({
  type: OIDC_USER_SIGNED_OUT,
});
